import { styled } from '@mui/system';
import { Drawer, ListItemButton, ListItemText, ListItemIcon } from '@mui/material';

export const StyledDrawer = styled(Drawer)(({ theme }) => ({
  flexShrink: 0,
  position: 'fixed',
  top: 0,
  '& .MuiDrawer-paper': {
    marginTop: '85px',
    width: '72px',
    overflowX: 'hidden',
    backgroundColor: theme.palette.background.secondary,
    boxSizing: 'border-box',
    boxShadow: 'none',
    border: 'none',
    height: '100vh',
  },
}));

// List Item Button styles
export const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  borderRadius: 0,
  '--icon-color': theme.colors.gray,

  '&:hover': {
    borderRadius: 0,
  },

  '&.active': {
    '--icon-color': theme.palette.text.primary,
    '& .MuiListItemText-root': {
      color: theme.palette.common.white,
    },
  },
}));

export const StyledListItemIcon = styled(ListItemIcon)(() => ({
  justifyContent: 'center',
}));

export const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  color: theme.colors.gray,
  textAlign: 'center',
}));
